var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-repeater-input"},[_c('Repeater',{attrs:{"control":{
      options: {
        repeaterOptions: _vm.options
      }
    }},scopedSlots:_vm._u([{key:"default",fn:function({ value: repeaterValue, index }){return [_c('OxygenControls',{attrs:{"controls":_vm.control.controls,"value":repeaterValue,"path":`${_vm.path}[${index}]`},on:{"input":function($event){return _vm.updateItem($event, index)}}})]}}]),model:{value:(_vm.syncedValue),callback:function ($$v) {_vm.syncedValue=$$v},expression:"syncedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }